<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important"
  >
    <section>
      <PageHeader pageTitle="Leads:extrair" style="padding-top: 1rem;">
        <div style="display: flex; gap: 0.5rem">
          <MunicipioSelect v-model="municipioList" />
          <CNAEFirstSelect
            v-if="municipioList.length"
            v-model="cnaeList"
            :selectedMunicipios="municipioList"
          />
        </div>
        <div style="display: flex; gap: 0.5rem; flex-direction: column;">
          Ano de início da atividade
          <div style="display: flex; gap: 0.5rem;">
            <SelectYear
              :startYear="1694"
              placeholderText="Ano inicial"
              v-model="minStartActivityYear" 
              style="width: 150px;"
            />
            <SelectYear
              :startYear=computedMaxStartYear 
              placeholderText="Ano final"
              v-model="maxStartActivityYear"
              style="width: 150px;"
            />
          </div>
        </div>
        <BaseButtonComponent
          variant="primary-action"
          style="padding: 1px 12px;"
          :disabled="isExtractButtonDisabled"
          @click="extractLead"
        >
          Extrair
        </BaseButtonComponent>
      </PageHeader>
    </section>
  </main>
</template>

<script>
import { CNAEFirstSelect } from '../../modules/leads/components';
import { MunicipioSelect } from '../../modules/leads/components';
import { SelectYear } from '../../ui/selects';
import { BaseButtonComponent } from '../../ui/buttons';
import { PageHeader } from '../../ui/page-header';
import { Api } from '../../vue/api';
const API = new Api();

export default {
  data() {
    return {
      isLoading: false,
      leads: [],
      cnaeList: [],
      municipioList: [],
      minStartActivityYear: null,
      maxStartActivityYear: null,
      computedMaxStartYear: 1694,
    };
  },
  components: {
    MunicipioSelect,
    PageHeader,
    CNAEFirstSelect,
    SelectYear,
    BaseButtonComponent,
  },
  watch: {
    minStartActivityYear(newVal) {
      this.computedMaxStartYear = Number(newVal) || 1694;
    }
  },
  computed: {
    isExtractButtonDisabled() {
      return !this.cnaeList.length || !this.municipioList.length || this.isLoading || 
             (this.minStartActivityYear && !this.maxStartActivityYear) || 
             (!this.minStartActivityYear && this.maxStartActivityYear);
    },
  },
  methods: {
    async extractLead() {
      if (!this.validateDates()) {
        this.showErrorToast('Por favor, selecione um período válido de ano de início da atividade.');
        return;
      }
      
      this.isLoading = true;
      const { ok, errors } = await API.post('/execute', {
        path: `/lead-management/extract`,
        method: 'post',
        data: {
          cnaeList: this.cnaeList,
          municipioList: this.municipioList,
          minStartActivityYear: this.minStartActivityYear,
          maxStartActivityYear: this.maxStartActivityYear
        },
      });
      this.isLoading = false;

      if (!ok) {
        this.showErrorToast(errors.message);
        return;
      }
    },
    validateDates() {
      return (
        (!this.minStartActivityYear && !this.maxStartActivityYear) || 
        (this.minStartActivityYear && this.maxStartActivityYear) && 
        this.maxStartActivityYear >= this.minStartActivityYear
      );
    },
    showErrorToast(message) {
      this.$bvToast.toast(message, {
        title: `Erro`,
        variant: 'error',
        solid: true,
      });
    }
  },
};
</script>
